module.exports = __webpack_public_path__ + "img/onboarding.ffb25a78.png";